@if (rulesWidget) {
    <mvs-widget
            [widgetData]="rulesWidget"
            (onObjectSelect)="onItemSelect($event)"
    ></mvs-widget>
}
